import React from 'react';
import {useIntl} from 'react-intl';
import {Button} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';
import {FieldArray} from 'formik';
import Item from './Item';
import moment from 'moment/moment';

const UnitGrid = ({values}) => {
  const intl = useIntl();
  const valuesSet = {
    accountNumber: '',
    amount: '',
    bankCode: '',
    branchNumber: '',
    checkNumber: '',
    description: '',
    dueDate: Date.parse(moment().format('YYYY-MM-DD')),
    paymentType: '',
  };

  const headerCellClassName = 'header-cell w-135px px-1';
  const headerClassName = `d-flex justify-content-between custom-brand-color header 
  pr-${values.lines.length > 8 ? '8' : '2'}`;
  const commonButtonClassName = 'custom-send-button col-2 mx-3';

  const columnDetails = intl.formatMessage({
    id: 'receipts-popup-grid-column-details',
    defaultMessage: 'Details',
  });
  const columnPaymentType = intl.formatMessage({
    id: 'receipts-popup-grid-column-payment-type',
    defaultMessage: 'Payment type',
  });
  const columnDate = intl.formatMessage({
    id: 'receipts-popup-grid-column-date',
    defaultMessage: 'Date',
  });
  const columnCheckNumber = intl.formatMessage({
    id: 'receipts-popup-grid-column-check-number',
    defaultMessage: 'Check number',
  });
  const columnBankCode = intl.formatMessage({
    id: 'receipts-popup-grid-column-bank-code',
    defaultMessage: 'Bank code',
  });
  const columnBranchNumber = intl.formatMessage({
    id: 'receipts-popup-grid-column-branch-number',
    defaultMessage: 'Branch number',
  });
  const columnAccountNumber = intl.formatMessage({
    id: 'receipts-popup-grid-column-account-number',
    defaultMessage: 'Account number',
  });
  const columnAmount = intl.formatMessage({
    id: 'receipts-popup-grid-column-amount',
    defaultMessage: 'Amount',
  });
  const buttonLabelAddLine = intl.formatMessage({
    id: 'receipts-popup-button-add-line',
    defaultMessage: 'Add line',
  });

  return (
    <div className="popup-add-receipt-grid my-3">
      <div className={headerClassName}>
        <div className={headerCellClassName}>
          {columnDetails}
        </div>
        <div className={headerCellClassName}>
          {columnPaymentType}
        </div>
        <div className={headerCellClassName}>
          {columnDate}
        </div>
        <div className={headerCellClassName}>
          {columnCheckNumber}
        </div>
        <div className={headerCellClassName}>
          {columnBankCode}
        </div>
        <div className={headerCellClassName}>
          {columnBranchNumber}
        </div>
        <div className={headerCellClassName}>
          {columnAccountNumber}
        </div>
        <div className={headerCellClassName}>
          {columnAmount}
        </div>
        <div className={'w-30px'}/>
      </div>
      <FieldArray name={'lines'}>
        {({remove, push}) => {
          return (
            <>
              <div className="w-100 py-1 add-receipt-grid-body">
                {(values.lines.length > 0) && values.lines.map((sets, index) => (
                  <div key={index} className="d-flex align-items-center py-1">
                    <Item
                      accountNumber={`lines.${index}.accountNumber`}
                      amount={`lines.${index}.amount`}
                      bankCode={`lines.${index}.bankCode`}
                      branchNumber={`lines.${index}.branchNumber`}
                      checkNumber={`lines.${index}.checkNumber`}
                      description={`lines.${index}.description`}
                      dueDate={`lines.${index}.dueDate`}
                      paymentType={`lines.${index}.paymentType`}
                      index={index}
                      onRemove={() => remove(index)}
                    />
                  </div>
                ))
                }
              </div>
              <div className={'d-flex justify-content-center mt-6 mx-auto'}>
                <Button
                  className={commonButtonClassName}
                  onClick={() => {
                    push(valuesSet);
                  }}
                >
                  <img
                    src={toAbsoluteUrl('/media/svg/Plus_square_white.svg')}
                    alt="add-row"
                    className="mr-2 w-20px"
                  />
                  {buttonLabelAddLine}
                </Button>
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
}

export default UnitGrid;
